import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const availableDishesService = {
  getAllSAvailableDishes: (currentData, bypass = false) =>
    axiosService
      .get(`${urls.menu.availableDishes}?date=${currentData}${bypass ? '&bypass=true' : ''}`)
      .then((value) => value.data),

  createASAvailableDishes: (data) =>
    axiosService
      .post(urls.menu.availableDishes, data)
      .then((value) => value.data),
  updateByDateOfDay: (currentData, data) =>
    axiosService.patch(
      `${urls.menu.availableDishes}?date=${currentData}`,
      data
    ),
  cloneAvailableDishes: (data) =>
    axiosService
      .post(`${urls.menu.availableDishes}/clone`, {}, { params: data })
      .then((value) => value.data),
};

export { availableDishesService };
